module.exports = __webpack_public_path__ + "img/honor10.0.1.0_202508261531.png";